import React from "react";
import {RiArrowLeftSLine, RiArrowRightSLine} from "react-icons/ri";
import {Button} from "reactstrap";
import "./pagination.scss";

type PaginationProps = {
  rowCount: any;
  rowsPerPage: any;
  onChangePage: any;
  onChangeRowsPerPage: any;
  currentPage: any;
  color?: string;
};
function getNumberOfPages(rowCount: any, rowsPerPage: any) {
  return Math.ceil(rowCount / rowsPerPage);
}

function toPages(pages: any) {
  const results = [];

  for (let i = 1; i <= pages; i++) {
    results.push(i);
  }

  return results;
}

export const BootyPagination: React.FC<PaginationProps> = (props) => {
  const {
    rowsPerPage,
    rowCount,
    onChangePage,
    onChangeRowsPerPage, // available but not used here
    currentPage,
    color,
  } = props;
  const handleBackButtonClick = () => {
    onChangePage(currentPage - 1);
  };

  const handleNextButtonClick = () => {
    onChangePage(currentPage + 1);
  };

  const handlePageNumber = (e: any) => {
    onChangePage(Number(e.target.value));
  };

  const pages = getNumberOfPages(rowCount, rowsPerPage);
  const pageItems = toPages(pages);
  const nextDisabled = currentPage === pageItems.length;
  const previosDisabled = currentPage === 1;

  return (
    <nav className="bottom-pagination">
      <ul className={`pagination pagination-${color}`}>
        <li className="page-item">
          <button
            className="page-link"
            onClick={handleBackButtonClick}
            disabled={previosDisabled}
            aria-disabled={previosDisabled}
            aria-label="previous page"
          >
            <RiArrowLeftSLine />
          </button>
        </li>
        {pageItems.map((page) => {
          const className =
            page === currentPage ? "page-item active" : "page-item";

          return (
            <li key={page} className={className}>
              <button
                className="page-link"
                onClick={handlePageNumber}
                value={page}
              >
                {page}
              </button>
            </li>
          );
        })}
        <li className="page-item">
          <Button
            className="page-link "
            onClick={handleNextButtonClick}
            disabled={nextDisabled}
            aria-disabled={nextDisabled}
            aria-label="next page"
          >
            <RiArrowRightSLine />
          </Button>
        </li>
      </ul>
    </nav>
  );
};
